export const GENDERS = [
  {
    id: 1,
    name: "Masculino"
  },
  {
    id: 2,
    name: "Femenino"
  }
];

export default {
  computed: {
    genders() {
      return GENDERS;
    }
  },
  methods: {
    genderName(gender_id) {
      return this.genders.find(g => g.id == gender_id)?.name;
    }
  }
};
